import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LanguageCode, defaultLanguageCode, languagesList } from '@app/models/language.model';
import { SelectButtonChangeEvent, SelectButtonModule } from 'primeng/selectbutton';

import { TranslateService } from '@ngx-translate/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    imports: [
    ReactiveFormsModule,
    SelectButtonModule,
    FormsModule,
    ],
    styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {
    private translate = inject(TranslateService);

    languageList = [...languagesList];
    languageSelected: LanguageCode = defaultLanguageCode;

    constructor() {
        const localStorageLanguage = localStorage.getItem('language');

        this.languageSelected =
        localStorageLanguage === 'en' || localStorageLanguage === 'sq' ? localStorageLanguage : defaultLanguageCode;
    }

    switchLanguage({value}: SelectButtonChangeEvent): void {
        this.translate.use(value);
        localStorage.setItem('language', value);
    }

}
